module.exports = __webpack_public_path__ + "images/auth-cover-4b226dcf120a3f5997f982776f8c6608.jpg";